import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, Optional, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../../api.service';
import { NavbarComponent } from '../../navbar/navbar.component';
import { isImage, maxSingleFileSizeMB } from '../constants';
import { ImageCroppedEvent, ImageCropperComponent, ImageTransform } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-file-upload',
	templateUrl: './file-upload.component.html',
	styleUrl: './file-upload.component.scss',
	providers: [NgbActiveModal]
})
export class FileUploadComponent {
	constructor(public modalService: NgbModal, public activeModal: NgbActiveModal, private sanitizer: DomSanitizer, private apiService: ApiService, public toastr: ToastrService, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) { }
	@Input() allowedFiles: string[] = [];
	@Input() cls: string = "";
	@Input() upload: boolean = true;
	@Input() disabled: boolean = false;
	@Input() uploadFolder: string = "";
	@Input() flag: boolean = false;
	@Input() show_toastr: boolean = true;
	@Input() maxFileSizeInMB: number = maxSingleFileSizeMB;
	@Output() uploaded = new EventEmitter<any>();
	@Output() selected = new EventEmitter<any>();
	fileUploadLoader = false;
	fileMsg: any[] = [];
	file!: File;
	croppedImgFile!: File;
	croppedImage: any = '';
	croppedDiam: any = {
		"width": "100%",
		"height": "auto"
	}
	showCropper = false;
	@ViewChild("imageCropper", { static: false }) imageCropper!: ImageCropperComponent;
	transform: ImageTransform = { rotate: 0 };
	@ViewChild('myModal') myModal!: TemplateRef<any>;
	modalRef!: NgbModalRef;

	public onFileSelectOld(files: NgxFileDropEntry[]) {
		this.fileMsg = [];
		for (let i = 0; i < files.length; i++) {
			const droppedFile = files[i];
			if (droppedFile.fileEntry.isFile && this.isFileAllowed(droppedFile.fileEntry.name)) {
				const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
				fileEntry.file((file: File) => {
					this.file = file;
					if (isImage(file.name)) {
						this.showCropper = true;
						this.modalRef = this.modalService.open(this.myModal, {
							backdrop: 'static',
							keyboard: false,
							ariaLabelledBy: 'modal-basic-title',
							fullscreen: true
						});
					} else {
						this.showCropper = false;
						this.continueUpload();
					}
				});
			} else {
				let msg = droppedFile.fileEntry.name + ". Only " + this.allowedFiles.toString() + " files are allowed.";
				this.toastr.error(msg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				if (!this.upload) {
					this.fileMsg.push({ msg: msg, isInvalid: true });
				}
			}
		}
	}

	public onFileSelect(files: NgxFileDropEntry[]) {
		this.fileMsg = [];
		for (let i = 0; i < files.length; i++) {
			const droppedFile = files[i];
			if (droppedFile.fileEntry.isFile && this.isFileAllowed(droppedFile.fileEntry.name)) {
				const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
				fileEntry.file((file: File) => {
					this.file = file;
					if (isImage(file.name)) {
						// Open cropper directly without initial size check
						this.showCropper = true;
						this.modalRef = this.modalService.open(this.myModal, {
							backdrop: 'static',
							keyboard: false,
							ariaLabelledBy: 'modal-basic-title',
							fullscreen: true
						});
					} else {
						// Validate size for non-image files before upload
						if (!this.isFileSizeAllowed(file.size)) {
							const msg = `${file.name} exceeds the maximum file size limit of ${this.maxFileSizeInMB}MB.`;
							this.toastr.error(msg, 'Error', {
								timeOut: 3000,
								tapToDismiss: true,
								closeButton: true
							});
							if (!this.upload) {
								this.fileMsg.push({ msg: msg, isInvalid: true });
							}
							return;
						}

						this.showCropper = false;
						this.continueUpload();
					}
				});
			} else {
				let msg = droppedFile.fileEntry.name + ". Only " + this.allowedFiles.toString() + " files are allowed.";
				this.toastr.error(msg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				if (!this.upload) {
					this.fileMsg.push({ msg: msg, isInvalid: true });
				}
			}
		}
	}

	imageCropped(event: ImageCroppedEvent) {
		if (event.objectUrl && event.blob) {
			this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl);
			/* this.croppedImgFile = new File([event.blob], "cropped.png", {
				type: event.blob.type || "image/png",
				lastModified: Date.now()
			}); */
			this.croppedImgFile = new File([event.blob], "cropped.jpeg", {
				type: event.blob.type || "image/jpeg",
				lastModified: Date.now()
			});
			if (this.imageCropper) {
				this.croppedDiam = {
					"width": (this.imageCropper.cropper.x2 - this.imageCropper.cropper.x1) + "px",
					"height": (this.imageCropper.cropper.y2 - this.imageCropper.cropper.y1) + "px"
				};
			}
		} else {
			this.toastr.error("Something went wrong", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		}
	}

	loadImageFailed() {
		this.toastr.error("Something went wrong", 'Error', {
			timeOut: 3000,
			tapToDismiss: true,
			closeButton: true
		});
	}

	saveCroppedImageOld() {
		if (this.croppedImgFile) {
			this.file = this.croppedImgFile;
			this.closeModal();
			this.continueUpload();
		} else {
			this.toastr.error("Something went wrong", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		}
	}

	saveCroppedImage() {
		if (this.croppedImgFile) {
			// Validate size of the cropped output
			if (!this.isFileSizeAllowed(this.croppedImgFile.size)) {
				this.toastr.error(`Cropped image exceeds the maximum file size limit of ${this.maxFileSizeInMB}MB.`, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				return; // Modal stays open so the user can recrop or zoom out
			}

			this.file = this.croppedImgFile;
			this.closeModal();
			this.continueUpload();
		} else {
			this.toastr.error("Something went wrong", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		}
	}

	isFileSizeAllowed(fileSize: number): boolean {
		const maxBytes = this.maxFileSizeInMB * 1024 * 1024; // Convert MB to Bytes
		return fileSize <= maxBytes;
	}

	continueUpload() {
		if (this.upload) {
			const formData = new FormData();
			formData.append('file', this.file);
			this.uploadFile(formData);
		} else {
			this.selected.emit(this.file);
			this.fileMsg.push({ msg: this.file.name, isInvalid: false });
		}
	}

	isFileAllowed(fileName: string) {
		let isFileAllowed = false;
		const regex = /(?:\.([^.]+))?$/;
		const extension = regex.exec(fileName);
		if (undefined !== extension && null !== extension) {
			for (const ext of this.allowedFiles) {
				if (ext.toLowerCase() === extension[0].toLowerCase()) {
					isFileAllowed = true;
				}
			}
		}
		return isFileAllowed;
	}

	uploadFile(formData: FormData) {
		formData.append("type", this.uploadFolder);
		formData.append("flag", this.flag.toString());
		this.fileUploadLoader = true;
		this.apiService.uploadFile(formData).subscribe({
			next: data => {
				this.fileUploadLoader = false;
				if (this.show_toastr) {
					this.toastr.success("File uploaded successfully.", 'Success', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true
					});
				}
				this.uploaded.emit(data);
			}, error: (error: any) => {
				this.fileUploadLoader = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	rotate(deg: number) {
		const next = ((this.transform.rotate ?? 0) + deg + 360) % 360;
		this.transform = { ...this.transform, rotate: next };
	}

	flipHorizontal() {
		this.transform = {
			...this.transform,
			flipH: !this.transform.flipH
		};
	}

	zoom(factor: number) {
		this.transform = {
			...this.transform,
			scale: (this.transform.scale || 1) + factor
		};
	}

	closeModal() {
		this.modalRef.close();
		this.transform = { rotate: 0 };
	}
}
